import { SetLoggedInAsAction } from '../actionTypes/miscActions';
import { VENDOR_REGISTRATION_SET_LOGGED_IN_AS } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const setLoggedInAs = (username: string): SetLoggedInAsAction => ({
  type: VENDOR_REGISTRATION_SET_LOGGED_IN_AS,
  payload: { username },
});
